import { Typography } from "@RHCommerceDev/utils/material-ui-core";
import { usePageContent } from "customProviders/LocationProvider";
import React, { FC } from "react";
import memoize from "utils/memoize";
import template from "lodash.template";
import { cn } from "@RHCommerceDev/utils/cn";

export interface EcoParticipationProps {
  ecofee?: string;
  ecoFeeText?: string;
  classNames?: string;
}

const EcoParticipation: FC<EcoParticipationProps> = ({
  ecofee,
  ecoFeeText,
  classNames
}) => {
  const { pageContent } = usePageContent();
  return (
    <Typography
      id="eco-participation-fee"
      className={cn(
        " items-baseline font-rhsans text-[10px] font-extralight leading-[18px] tracking-[0.04rem] text-rh-dark",
        classNames
      )}
    >
      {template(pageContent?.INCLUDES_ECO_PARTICIPATION || ecoFeeText)({
        formattedPrice: ecofee
      })}
    </Typography>
  );
};

export default memoize(EcoParticipation);
